__turbopack_context__.v({
  "className": "inter_9155b79f-module__NXcPaG__className",
  "variable": "inter_9155b79f-module__NXcPaG__variable",
});
